module.exports = __webpack_public_path__ + "img/autarky_navbar_bg.c086b6c0.png";